/* unplugin-vue-components disabled */import script from "./data.vue?vue&type=script&setup=true&name=Data&lang=js"
export * from "./data.vue?vue&type=script&setup=true&name=Data&lang=js"

const __exports__ = script;

export default __exports__